import React, {useState} from "react";
import TableList from "../../../component/TableList/TableList";
import FilterRecebivelRural from "./FilterRecebivelRural";
import {statusList, typeList} from "./lists";
import {numberWithPoints} from "../../../utils/numberWithPoints";
import PopupAddRecebivel from "./PopupAddRecebivel";
import {normalizeTimestemp} from "../../../utils/normalizeTimestemp";
import RecebivelRuralActions from "./RecebivelRuralActions";
import DownloadBoleto from "../../../component/DownloadBoleto/DownloadBoleto";

export default function RecebivelRuralList({
                                               baseUrl, loadData,
                                               setLoadData, size, page,
                                               setTotalPages, setTotalElements,
                                               sort, setPage
                                           }) {

    const [data, setData] = useState([])
    const [error, setError] = useState(false)
    const [filter, setFilter] = useState({})

    const titles = [
        'Cliente',
        'Tipo',
        'Valor',
        'Status',
        'Vencimento'
    ]

    const getTipo = (tipo) => typeList.filter(qtt => qtt.value === tipo)[0].label

    return (
        <>
            <FilterRecebivelRural filter={filter} setFilter={setFilter} setLoadData={setLoadData} setPage={setPage}/>
            <PopupAddRecebivel baseUrl={baseUrl} setLoadData={setLoadData}/>
            <TableList
                titles={titles} baseUrl={baseUrl + '/list'}
                page={page} sort={sort} size={size}
                loadData={loadData}
                setTotalPages={setTotalPages} setTotalElements={setTotalElements}
                setData={setData} setLoadData={setLoadData} filter={filter}
                error={error} setError={setError}
            >
                {data.map((item) =>
                    <tr key={item.id}>
                        <td>{item.nomeParticipante} - {item.documentoParticipante}</td>
                        <td>{getTipo(item.tipo)}</td>
                        <td>R$ {numberWithPoints(item.valor)}</td>
                        <td>{statusList.filter(qtt => qtt.value === item.status)[0].label}</td>
                        <td>{normalizeTimestemp(item.vencimento)}</td>
                        <td>
                            <span className='d-inline-block'>
                                <DownloadBoleto
                                    boletoId={item.boletoId}
                                    filename={`boleto ${item.nomeParticipante} - ${item.id}`}
                                    disabled={item.boletoId === null}
                                />
                            </span>
                            <span className='d-inline-block'>
                                <RecebivelRuralActions item={item} baseUrl={baseUrl}/>
                            </span>
                        </td>
                    </tr>
                )}
            </TableList>
            <br/>
        </>
    )
}